import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  filter  map 
export const filtermap = createSlice({
  name: "filtermap",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    data: {},
  },

  reducers: {
    edit_filtermap: (state, action) => {
      state.data = action.payload;
    },
    success_api_call_filtermap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
    },
    failure_api_call_filtermap: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
    },
    filtermap_is_success: (state) => {
      state.isSuccess = false;
    },
    filtermap_complete_api: (state) => {
      state.api_completed = false;
    },
  },
});
export default filtermap.reducer;
export const {
  edit_filtermap,
  success_api_call_filtermap,
  filtermap_complete_api,
  failure_api_call_filtermap,
  filtermap_is_success,
} = filtermap.actions;
